module.exports = __webpack_public_path__ + "media/images/form-status-retired-c7df8453.gif";